/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 11
// module chunks = 1